/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Box } from "@mui/material";
import { Vocabulary } from "../../../Utils/Vocabulary";
import RenderVariant from "./RenderVariant";
import EditMultipleVariants from "./EditMultipleVariants";
import { ProductModel, ProductStockModel } from "../../../Utils/Models";
import SelectedVariantsButtons from "./SelectedVariantsButtons";

export type VariantProps = {
  [key: string]:
    | string
    | number
    | boolean
    | Array<string | any>
    | undefined
    | null;
  inventories: ProductStockModel[];
  images: Array<string | any> | null;
  mustBeDeleted: boolean;
};

type ProductVariantsProps = {
  product: ProductModel;
  variants: Array<VariantProps>;
  handleChangeVariants: (variants: Array<any>) => void;
  handleChangeProduct: (product: ProductModel) => void;
};

export type EditModalProps = {
  openModal: boolean;
  pricePerQuantity: number;
  totalPrice: number;
  quantity: number;
};

export default function ProductVariants(props: ProductVariantsProps) {
  const { product, variants, handleChangeVariants, handleChangeProduct } =
    props;
  const [selectedVariants, setSelectedVariants] = useState<Array<number>>([]);
  const [editModal, setEditModal] = useState<EditModalProps>({
    openModal: false,
    pricePerQuantity: 0,
    totalPrice: 0,
    quantity: 0,
  });

  /**
   *
   * @param index
   */
  function handleChangeSelectedVariants(index: number) {
    const newSelectedVariants = selectedVariants.slice();
    if (selectedVariants.includes(index)) {
      newSelectedVariants.splice(newSelectedVariants.indexOf(index), 1);
    } else {
      newSelectedVariants.push(index);
    }
    setSelectedVariants(newSelectedVariants);
  }
  /**
   *
   * @param index
   * @param variant
   */
  function changeOneVariant(index: number, variant: VariantProps) {
    const newVariants = variants.slice();
    newVariants[index] = variant;

    //TODO asta nu stiu daca o pun sau nu
    // const totalQuantity = newVariants.reduce((variantSum, variant) => {
    //   const inventorySum = variant.inventories.reduce(
    //     (inventorySum, inventory) => {
    //       return inventorySum + (+inventory.quantity || 0);
    //     },
    //     0
    //   );
    //   return variantSum + inventorySum;
    // }, 0);
    // if (totalQuantity > product.inventories[0].quantity) {
    //   return;
    // }
    handleChangeVariants(newVariants);
  }

  /**
   *
   */
  function handleRemoveVariant() {
    const newVariants: any = variants.slice();
    selectedVariants.forEach((index) => {
      newVariants[index].mustBeDeleted = true;
    });
    handleChangeVariants(newVariants);
    setSelectedVariants([]);
  }

  /**
   *
   * @param name
   * @param value
   */
  function handleEditVariantInformation() {
    const newVariants: any = variants.slice();

    selectedVariants.forEach((index) => {
      newVariants[index].inventories.forEach((inventory: any) => {
        inventory.pricePerQuantity = editModal.pricePerQuantity;
        inventory.totalPrice = editModal.totalPrice;
        inventory.quantity = editModal.quantity;
      });
    });
    handleChangeVariants(newVariants);
    setSelectedVariants([]);
  }

  /**
   *
   * @param newEditModal
   */
  function handleEditModal(newEditModal: EditModalProps) {
    setEditModal(newEditModal);
  }

  /**
   *
   * @param indexes
   */
  function undoDeleteVariant(indexes: Array<number>) {
    const newVariants: any = variants.slice();
    indexes.forEach((index) => {
      newVariants[index].mustBeDeleted = false;
    });
    handleChangeVariants(newVariants);
    setSelectedVariants([]);
  }
  return (
    <>
      <Box
        component="fieldset"
        style={{ border: "1px solid #ccc", borderRadius: 4, margin: 10 }}
      >
        <legend style={{ color: "#999999" }}>{Vocabulary.variants}</legend>
        {selectedVariants.length !== 0 ? (
          <SelectedVariantsButtons
            selectedVariants={selectedVariants}
            handleRemoveVariant={handleRemoveVariant}
            undoDeleteVariant={undoDeleteVariant}
            editPriceOrQuantity={() =>
              setEditModal({
                openModal: true,
                pricePerQuantity: 0,
                totalPrice: 0,
                quantity: 0,
              })
            }
          />
        ) : null}

        {variants && variants.length !== 0 ? (
          <>
            {variants.map((variant, index) => (
              <RenderVariant
                key={`${variant}_${index}`}
                index={index}
                product={product}
                variant={variant}
                selectedVariants={selectedVariants}
                changeOneVariant={changeOneVariant}
                handleChangeSelectedVariants={handleChangeSelectedVariants}
                undoDeleteVariant={undoDeleteVariant}
                handleChangeProduct={handleChangeProduct}
              />
            ))}
          </>
        ) : null}
      </Box>
      <EditMultipleVariants
        editModal={editModal}
        handleEditModal={handleEditModal}
        handleEditVariantInformation={handleEditVariantInformation}
      />
    </>
  );
}
